const CDN_BASE = "https://jiritsu.fra1.cdn.digitaloceanspaces.com";

/** Resolves a storybook beat illustration on the CDN. */
export function resolveStorybookAsset(beatIndex: number, slug: string): string {
  const padded = String(beatIndex).padStart(2, "0");
  return `${CDN_BASE}/storybook/island/${padded}-${slug}.webp`;
}
